import styled from 'styled-components'

import { PriceStyled } from '@webapp/core/components/Price/styles/PriceStyled'

export const FrequencyWrapperStyled = styled.div`
  min-width: ${(props) => props.theme.typography.pxToRem(100)};
  color: ${(props) => props.theme.colors.darkGrey};
  ${PriceStyled} {
    color: ${(props) => props.theme.colors.darkGrey};
    font-weight: ${(props) => props.theme.fontWeights.bold};
    display: inline-block;
  }
`
